import axiosInstance from '../utils/axiosConfig';
// ── Closed months: each company's "Books closed up to" month ─────────────
// Its own file so screen checks that stand in for invoicingService never
// break the month box.
// The server owns the rule (invoicing/services/reporting_month.py); the month
// box only mirrors it so a closed month turns red before saving.

export const fetchBooksClosed = async () => {
  const response = await axiosInstance.get('/api/invoicing/books-closed/');
  return response.data;
};

export const closeBooks = async (entityId, month) => {
  const response = await axiosInstance.post('/api/invoicing/books-closed/', {
    hms_entity: entityId,
    closed_through: month,
  });
  return response.data;
};

// One read per page load, shared by every month box on the page.
let booksClosedRead = null;

export const closedThroughFor = async (entityId) => {
  if (!entityId) return null;
  if (!booksClosedRead) {
    booksClosedRead = fetchBooksClosed().catch((error) => {
      booksClosedRead = null;
      // The server still refuses a closed month on save; the box just can't warn early.
      console.warn('Closed months could not be read; the box will not warn before saving.', error);
      return { companies: [] };
    });
  }
  const data = await booksClosedRead;
  const id = typeof entityId === 'object' ? entityId.id : entityId;
  const company = (data.companies || []).find((c) => String(c.id) === String(id));
  return company ? company.closed_through : null;
};

// After a change on the Closed months page, the next box reads afresh.
export const forgetBooksClosed = () => {
  booksClosedRead = null;
};
